// utils/buildCameraTargets.js
// export const buildCameraTargets = (totalQuestion, layout = 9) => {
//   const step = Math.ceil(totalQuestion / layout)
//   return Array.from({ length: layout }, (_, i) => Math.min((i + 1) * step, totalQuestion))
// }

export const buildCameraTargets = (totalQuestion, layout = 9) => {
  const targets = []

  for (let i = 1; i <= layout; i++) {
    let val = Math.floor((i * totalQuestion) / layout)

    // guard biar gak duplicate
    if (targets.includes(val)) {
      val = targets[targets.length - 1] + 1
    }

    // guard biar gak lebih dari total
    if (val > totalQuestion) val = totalQuestion

    targets.push(val)
  }

  return targets
}
